import Alert from './Alert';
import NavigableLink from './NavigableLink';
import PrintButton from './PrintButton';
import CDialog from './CDialog';
import HeadersDetail from './HeadersDetail';
import LoadingDialog from './LoadingDialog';
import Exception from './Exception';
import AlertLeave from './AlertLeave';
import ModalLeave from './ModalLeave';
import ModalDelete from './ModalDelete';
import EntiteActions from './EntiteActions';
import EntiteActionsMobile from './EntiteActionsMobile';

import FooterRGPD from './FooterRGPD';

export default {
  install(Vue) {
    Vue.component('alert', Alert);
    Vue.component('navigable-link', NavigableLink);
    Vue.component('c-dialog', CDialog);
    Vue.component('headers-detail', HeadersDetail);
    Vue.component('loading-dialog', LoadingDialog);
    Vue.component('exception', Exception);
    Vue.component('alert-leave', AlertLeave);
    Vue.component('footer-rgpd', FooterRGPD);
    Vue.component('entiteActions', EntiteActions);
    Vue.component('entiteActionsMobile', EntiteActionsMobile);
    Vue.component('entiteModificationModal', ModalLeave);
    Vue.component('entiteSuppressionModal', ModalDelete);
    Vue.component('printButton', PrintButton);
  },
};
